/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompleteChallengeProfileBody
 */
export interface CompleteChallengeProfileBody {
    /**
     * ISO-3166-1 alpha-2 country code (e.g. "US"). Required when the membership has no declaredCountry on file.
     * @type {string}
     * @memberof CompleteChallengeProfileBody
     */
    declaredCountry?: string;
    /**
     * U.S. state code (e.g. "NY"). Required when declaredCountry is "US" and the membership has no declaredState on file.
     * @type {string}
     * @memberof CompleteChallengeProfileBody
     */
    declaredState?: string;
    /**
     * Per-challenge attestation map keyed by `Challenge.eligibilityCheckboxes[].key`. Each required checkbox must arrive as true. Ignored when the membership already carries `acceptedTermsAt`.
     * @type {{ [key: string]: boolean; }}
     * @memberof CompleteChallengeProfileBody
     */
    eligibility?: { [key: string]: boolean; };
    /**
     * Snapshot of the terms-of-use version the user is attesting to. Persisted alongside acceptedTermsAt.
     * @type {string}
     * @memberof CompleteChallengeProfileBody
     */
    termsVersion?: string;
}

/**
 * Check if a given object implements the CompleteChallengeProfileBody interface.
 */
export function instanceOfCompleteChallengeProfileBody(value: object): value is CompleteChallengeProfileBody {
    return true;
}

export function CompleteChallengeProfileBodyFromJSON(json: any): CompleteChallengeProfileBody {
    return CompleteChallengeProfileBodyFromJSONTyped(json, false);
}

export function CompleteChallengeProfileBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteChallengeProfileBody {
    if (json == null) {
        return json;
    }
    return {
        
        'declaredCountry': json['declaredCountry'] == null ? undefined : json['declaredCountry'],
        'declaredState': json['declaredState'] == null ? undefined : json['declaredState'],
        'eligibility': json['eligibility'] == null ? undefined : json['eligibility'],
        'termsVersion': json['termsVersion'] == null ? undefined : json['termsVersion'],
    };
}

export function CompleteChallengeProfileBodyToJSON(json: any): CompleteChallengeProfileBody {
    return CompleteChallengeProfileBodyToJSONTyped(json, false);
}

export function CompleteChallengeProfileBodyToJSONTyped(value?: CompleteChallengeProfileBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'declaredCountry': value['declaredCountry'],
        'declaredState': value['declaredState'],
        'eligibility': value['eligibility'],
        'termsVersion': value['termsVersion'],
    };
}

